/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Badge_Manual_IssuedInputs */

const vi_einvoice_badge_manual_issued = /** @type {(inputs: Einvoice_Badge_Manual_IssuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xuất trên MISA`)
};

/**

* @param {Einvoice_Badge_Manual_IssuedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_badge_manual_issued = /** @type {((inputs?: Einvoice_Badge_Manual_IssuedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Badge_Manual_IssuedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_badge_manual_issued(inputs)
});